<template lang="pug">
div.theheader
  vm-navbar(class="nabar" type="border")
    router-link(to='/')
      .logo-header
        img(src='@/assets/logo.png', alt='Logo', height=40)
    vm-spacer
    vm-navbar-item(index="0")
      vm-dropdown
        vm-button(type="flat" radius icon="bell-outline" color="#afbbc6")

        vm-dropdown-menu
          .heading.d-flex.justify-content-between
            h4 {{ $t('strings.notifications') }}
            vm-button(type="flat" size="small") {{ $t('strings.see_all') }}
          vm-dropdown-item.nonotifications(divider) {{ $t('strings.no_notifications') }}
    vm-navbar-item(index="0")
      vm-dropdown
        vm-button(type="flat" radius icon="email-outline" color="#afbbc6")

        vm-dropdown-menu
          .heading.d-flex.justify-content-between
            h4 {{ $t('strings.messages') }}
            vm-button(type="flat" size="small") {{ $t('strings.see_all') }}
          vm-dropdown-item.nonotifications(divider) {{ $t('strings.no_messages') }}
    vm-navbar-item(index="1")
      vm-dropdown
        .portraitContainer
          #portrait-header {{ firstLetters }}

        vm-dropdown-menu
          vm-dropdown-item {{ $auth.user().name }}
          vm-dropdown-item(@click="logout" divider) {{ $t('strings.exit') }}

  vm-navbar(class="sub-nabar", text-color="rgba(var(--gray),1)", active-text-color="rgba(var(--primary),1)")
    vm-spacer
    vm-navbar-item(index="0" v-for="(item, i) in menuItems" :key="i")
      router-link(:to='item.link')
        vm-icon(:icon="item.icon" size="1.4rem")
        span {{ $t(item.name) }}
    vm-spacer
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'TheHeader',
  methods: {
    ...mapActions([
      'resetAll'
    ]),
    colorGenerator () {
      this.mycolor = '#' + (Math.random() * 0xFFFFFF << 0).toString(16)
      document.getElementById('portrait-header').style.backgroundColor = this.mycolor
    },
    logout () {
      this.resetAll()
      this.$auth.logout({
        makeRequest: true,
        redirect: { name: 'login' }
      })
    }
  },
  mounted () {
    this.colorGenerator()
  },
  computed: {
    ...mapGetters([
      'menuItems'
    ]),
    firstLetters () {
      let res = ''
      let str = this.$auth.user().name
      if (str) {
        let matches = str.match(/\b(\w)/g)
        let acronym = matches.join('')
        res = acronym.substring(0, 1)
      }
      return res
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.theheader {
  position: fixed;
  width: 100%;
  background: white;
  z-index: 10000;
  .nabar {
    padding: .4rem 1rem;
    .logo-header {
      margin-left: 25px;
    }
    .vm-navbar--item {
      padding: 0 10px;
      display: flex;
      .con-vm-avatar {
        margin: 0;
      }
    }
  }
  .sub-nabar{
    .vm-navbar--item {
      padding: 5px 10px;
      margin: 0px 10px;
      .router-link-active {
        i {
          color: rgba(var(--primary),1);
        }
        ~.vm-navbar-after {
            width: 100%;
        }
      }
      span {
        margin-top: 3px;
      }
      a {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
    }
  }
}
.portraitContainer {
  text-align: center;
  height: 32px;
}
#portrait-header {
  height: 100%;
  border-radius: 50%;
  height: 32px;
  padding-top: 2px;
  color: white;
  font-weight: bold;
  font-size: 1.2rem;
  background-size: cover;
  object-fit: cover;
  width: 32px;
  display: inline-block;
}
.heading {
  min-width: 180px;
  padding: 2px 12px;
  h4 {
    padding-top: 3px;
  }
}
.nonotifications {
  text-align: center;
}
.theheader .sub-nabar .vm-navbar--item span {
    margin-top: 3px;
    margin-left: 14px;
}
</style>
